export default __webpack_public_path__ + "static/image3-94031b900f87808b4de205295eba9538.jpeg";